import { create } from 'zustand';

export enum NotificationType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning'
}

type NotificationAction = {
  label: string;
  onClick: () => void;
};

type NotificationPayload = {
  type: string;
  message: string;
  duration?: number;
  key?: string | number;
  persist?: boolean;
  action?: NotificationAction;
};

type NotificationState = {
  notification: NotificationPayload;
  setNotification: (notification: NotificationPayload) => void;
  removeNotification: () => void;
};

export const useNotificationStore = create<NotificationState>(set => ({
  notification: {
    type: '',
    message: '',
    duration: 5000,
  },
  setNotification: (notification: NotificationPayload) => {
    set(() => ({
      notification: {
        type: notification.type,
        message: notification.message,
        duration: notification.duration,
        key: notification.key,
        persist: notification.persist,
        action: notification.action,
      },
    }));
  },
  removeNotification: () => {
    // console.log('Removing notification');
    set(() => ({
      notification: {
        type: '',
        message: '',
        duration: 0,
      },
    }));
  },
}));
